// ======================================================================
// File: src/modules/ppe/pages/procurement/purchaseInvoice/view/components/PurchaseInvoiceWorkflowPanel.jsx
// Module: PPE → Procurement → Purchase Invoice
//
// Purpose:
// - Workflow action panel
// - Status driven actions
// - Sticky right-side workflow controls
//
// Workflow:
//
// DRAFT
//   Save
//   Submit
//
// SUBMITTED
//   Approve
//
// APPROVED
//   Post
//
// POSTED
//   View Only
//
// Notes:
// - Submit disabled when unsaved changes exist
// - User must Save before Submit
// - Approve/Post confirmation included
// ======================================================================

import React from "react";

const PurchaseInvoiceWorkflowPanel = ({
  status,
  dirty = false,
  onSave,
  onSubmit,
  onApprove,
  onPost
}) => {

  const handleSubmit = async () => {
    if (dirty) {
      alert(
        "Please save changes before submitting."
      );
      return;
    }

    const confirmed = window.confirm(
      "Submit Purchase Invoice?"
    );

    if (!confirmed) return;

    await onSubmit();
  };

  const handleApprove = async () => {
    const confirmed = window.confirm(
      "Approve Purchase Invoice?"
    );

    if (!confirmed) return;

    await onApprove();
  };

  const handlePost = async () => {
    const confirmed = window.confirm(
      "Post Purchase Invoice?\n\nThis action may create accounting entries."
    );

    if (!confirmed) return;

    await onPost();
  };

  const renderActions = () => {

    switch (status) {

      case "DRAFT":
        return (
          <>
            <button
              className="pi-btn pi-btn-primary"
              onClick={onSave}
            >
              Save
            </button>

            <button
              className="pi-btn pi-btn-success"
              disabled={dirty}
              onClick={handleSubmit}
            >
              Submit
            </button>

            {dirty && (
              <div className="pi-workflow-warning">
                Save changes before submit
              </div>
            )}
          </>
        );

      case "SUBMITTED":
        return (
          <>
            <button
              className="pi-btn pi-btn-success"
              onClick={handleApprove}
            >
              Approve
            </button>
          </>
        );

      case "APPROVED":
        return (
          <>
            <button
              className="pi-btn pi-btn-primary"
              onClick={handlePost}
            >
              Post
            </button>
          </>
        );

      case "POSTED":
        return (
          <div className="pi-posted-message">
            Document Posted
            <br />
            Read Only
          </div>
        );

      default:
        return (
          <div className="pi-posted-message">
            No Actions Available
          </div>
        );
    }
  };

  return (
    <div className="pi-card pi-workflow-panel">

      <div className="pi-card-title">
        Workflow Actions
      </div>

      <div className="pi-workflow-status">

        <div className="pi-status-label">
          Current Status
        </div>

        <div
          className={`pi-status-value status-${(
            status || ""
          ).toLowerCase()}`}
        >
          {status || "DRAFT"}
        </div>

      </div>

      <div className="pi-workflow-actions">
        {renderActions()}
      </div>

    </div>
  );
};

export default PurchaseInvoiceWorkflowPanel;